import { render, staticRenderFns } from "./DisplayError.vue?vue&type=template&id=1b239619&"
import script from "./DisplayError.vue?vue&type=script&lang=js&"
export * from "./DisplayError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports